export const STORAGE = {
  OTP_TIMER: "OTP_TIMER",
};

export const ONBOARDING_PAGE_ID = {
  USER_PERSONAL_DETAILS: "user_personal_details",
  USER_PROFILE_PIC: "user_profile_pic",
  USER_PROFESSIONAL_DETAILS: "user_professional_details",
  USER_SOCIALS: "user_socials",
};

export const MESSAGE = {
  API_ERROR: "Something Went Wrong.",
};

export const MODAL_NAME = {
  CREATE_POST: "CREATE_POST",
  GROUP_CHAT: "GROUP_CHAT",
  DELETE_POST: "DELETE_POST",
  REPORT: "REPORT",
  BECOME_MEMBER: "BECOME_MEMBER",
  REPORT_USER: "REPORT_USER",
  REPORT_REACTION: "REPORT_REACTION",
  DELETE_REACTION: "DELETE_REACTION",
};

export const LEADERBOARD_TABS = ["daily", "weekly", "lifetime"];

export const MIME_TYPE_MAPPING = {
  "application/pdf": "PDF",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": "XLS",
  "application/vnd.ms-excel": "XLS",
  "application/msword": "DOC",
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    "DOC",
};

export const paymentBaseURL = process.env.REACT_APP_PAYMENT_MEMBERSHIP_URL;
